export default {
  overview: {
    title: "Additional Effort Overview",
    archive_title: "Archived additional efforts",
    subtitle: "List of all additional efforts.",
    actions: {
      create_new: "Create New Additional Effort",
    },
    search: {
      placeholder: "eg. Name",
    },
    table: {
      headers: {
        id: "ID",
        name: "Name",
        unit: "Unit",
        purchasePrice: "Real Price",
        createdAt: "Created at",
      },
      empty: {
        prices: "Not set",
      },
    },
  },
  detail: {
    title: "Additional Effort Details",
    actions: {
      update: "Save",
    },
    tabs: {
      general: "General",
      files: "File storage",
      activity: "Activity",
    },
    form: {
      name: "Name",
      unit: "Unit",
      purchasePrice: "Real Price",
      purchaseUnit: "Real Price Unit",
      note: "Notes",
      sections: {
        base_data: "Master data",
        purchase: "Price",
        note: "Note",
      },
    },
  },
  create: {
    title: "Create Additional Effort",
    subtitle: "Create a new Additional Effort.",
  },
  component: {
    autocomplete: {
      noDataText: "Additional Effort not found {value}",
    },
  },
}
